class PredictiveSearch extends HTMLElement {
    constructor() {
        super();

        this.input = this.querySelector('input[type="search"]');
        this.predictiveSearchResults = document.querySelector('#predictive-search');
        this.searchResultsWrapper = document.querySelector(".search-results-wrapper");
        this.searchResultsInner = document.querySelector(".search-results-inner");
        this.searchResultsClose = document.querySelector(".search-results-close");
        this.recipesUrl = document.querySelector("#predictive-search").dataset.recipesUrl;
        this.magazineUrl = document.querySelector("#predictive-search").dataset.magazineUrl;

        this.searchResultsClose.addEventListener("click", (event) => {
            this.close(event);
        });

        this.searchResultsInner.addEventListener("mouseleave", (event) => {
            this.close(event);
        });

        this.input.addEventListener('input', this.debounce((event) => {
            this.onChange(event);
        }, 300).bind(this));

        this.input.addEventListener('focus', this.debounce((event) => {
            this.onChange(event);
        }, 300).bind(this));

        this.input.addEventListener('click', this.debounce((event) => {
            this.onChange(event);
        }, 300).bind(this));
    }

    onChange() {
        const searchTerm = this.input.value.trim();

        if (!searchTerm.length) {
            this.close();
            return;
        }

        this.getSearchResults(searchTerm);
    }

    async getSearchResults(searchTerm) {
        const searchTermClean = searchTerm.replaceAll("tag:magazin", "").replaceAll("tag:rezept", "").trim();
        const suggestProductUrl = `/search/suggest?q=${searchTermClean}&resources[type]=product&resources[options][fields]=title,product_type,vendor,body,tag,variants.barcode,variants.sku,variants.title&resources[limit]=6&section_id=predictive-search`;
        const suggestRecipeUrl = `/search/suggest?q=${searchTermClean}+tag%3Arezept&resources[type]=article&resources[options][fields]=title,body,tag&resources[limit]=3&section_id=predictive-search`;
        const suggestMagazineUrl = `/search/suggest?q=${searchTermClean}+tag%3Amagazin&resources[type]=article&resources[options][fields]=title,body,tag&resources[limit]=3&section_id=predictive-search`;

        try {
            const [responseProducts, responseRecipes, responseMagazines] = await Promise.all([
                fetch(suggestProductUrl),
                fetch(suggestRecipeUrl),
                fetch(suggestMagazineUrl)
            ]);

            if (!responseProducts.ok || !responseRecipes.ok || !responseMagazines.ok) {
                throw new Error('Mindestens eine Suchanfrage ist fehlgeschlagen');
            }

            const [htmlProducts, htmlRecipes, htmlMagazines] = await Promise.all([
                responseProducts.text(),
                responseRecipes.text(),
                responseMagazines.text()
            ]);

            const parser = new DOMParser();

            const docProducts = parser.parseFromString(htmlProducts, 'text/html');
            const docRecipes = parser.parseFromString(htmlRecipes, 'text/html');
            const docMagazines = parser.parseFromString(htmlMagazines, 'text/html');

            const recipeSection = docRecipes.querySelector('.predictive-search-results__recipes');
            const magazineSection = docMagazines.querySelector('.predictive-search-results__magazines');

            const targetRecipeContainer = docProducts.querySelector('.predictive-search-results__recipes');
            const targetMagazineContainer = docProducts.querySelector('.predictive-search-results__magazines');

            targetRecipeContainer.innerHTML = recipeSection.innerHTML;
            targetMagazineContainer.innerHTML = magazineSection.innerHTML;

            const resultsMarkup = docProducts.querySelector('#shopify-section-predictive-search').innerHTML;

            this.predictiveSearchResults.innerHTML = resultsMarkup;
            document.querySelector(".predictive-search-results__recipes-button").href = "/search?q="+searchTermClean+"+tag%3Arezept&options%5Bprefix%5D=last&type=article";
            if(this.magazineUrl){
                document.querySelector(".predictive-search-results__magazines-button").classList.remove('predictive-search-results__magazines-button--hidden');
                document.querySelector(".predictive-search-results__magazines-button").href = "/search?q="+searchTermClean+"+tag%3Amagazin&options%5Bprefix%5D=last&type=article";
            } else {
                document.querySelector(".predictive-search-results__magazines-button").classList.add('predictive-search-results__magazines-button--hidden');
            }

            this.open();

        } catch (error) {
            this.close();
            throw error;
        }
    }

    open() {
        this.predictiveSearchResults.classList.remove("hidden-menu");
        this.searchResultsWrapper.classList.remove("hidden-menu");
    }

    close() {
        this.predictiveSearchResults.classList.add("hidden-menu");
        this.searchResultsWrapper.classList.add("hidden-menu");
    }

    debounce(fn, wait) {
        let t;
        return (...args) => {
            clearTimeout(t);
            t = setTimeout(() => fn.apply(this, args), wait);
        };
    }
}

customElements.define('predictive-search', PredictiveSearch);

(function ($) {
    $( document ).ready(function() {
        $('#predictive-search').on('click', '.predictive-search__mobile-select-button', function() {
            $('.predictive-search__mobile-select-button').removeClass('predictive-search__mobile-select-button--active');
            $(this).addClass('predictive-search__mobile-select-button--active');
            $('.predictive-search-results__section').addClass('predictive-search-results__mobile-hidden');
            let select = $(this).data('select');
            $('.predictive-search-results__section[data-select="' + select + '"]').removeClass("predictive-search-results__mobile-hidden");
        } );

        $('#predictive-search').on('click', '#predictive-search-submit', function () {
            $('predictive-search form').submit();
        });
    });
})(jQuery);
